export { Address4 } from './ipv4';
export { Address6 } from './ipv6';
export { AddressError } from './address-error';

import * as helpers from './v6/helpers';

export const v6 = { helpers };
